import {FC, useEffect, useState} from 'react'

import './Pagination.scss'
import {PaginationProps} from './_core/_models'

const Pagination: FC<PaginationProps> = ({limite, pagina, total, query, handleList}) => {
  const [totalPages, setTotalPages] = useState<number>(1)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [maxPagesToShow] = useState<number>(5)
  const startPage = Math.max(1, currentPage - 2) // Calcula a primeira página a ser mostrada
  const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1) // Calcula a última página a ser mostrada

  useEffect(() => {
    setTotalPages(Math.ceil(total / limite))
  }, [total])

  return (
    <>
      <div className='pagination-container'>
        {total > 1 && (
          <div className='total'>
            Total de registros: {total}{' '}
            {totalPages > 1 && (
              <>
                (página {pagina} de {totalPages})
              </>
            )}
          </div>
        )}

        {totalPages > 1 && (
          <div>
            <ul className='pagination'>
              <li className={`page-item previous ${pagina === 1 && 'disabled'}`}>
                <button
                  className='page-link'
                  onClick={() => {
                    handleList(pagina - 1, limite, query)
                    setCurrentPage(pagina - 1)
                  }}
                >
                  <i className='previous'></i>
                </button>
              </li>
              {Array.from(Array(endPage + 1 - startPage), (_, i) => startPage + i).map((page) => (
                <li className={`page-item ${currentPage === page ? 'active' : ''}`}>
                  <button
                    className='page-link'
                    onClick={() => {
                      handleList(page, limite, query)
                      setCurrentPage(page)
                    }}
                  >
                    {page}
                  </button>
                </li>
              ))}
              <li className={`page-item previous ${pagina === totalPages && 'disabled'}`}>
                <button
                  className='page-link'
                  onClick={() => {
                    handleList(pagina + 1, limite, query)
                    setCurrentPage(pagina + 1)
                  }}
                >
                  <i className='next'></i>
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  )
}

export default Pagination
